import { useRef } from 'react';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { useTracker } from '../tracking/useTracker';
import { StyledGoogleLogoPlaceholder, StyledGoogleOAuthButton, StyledGoogleOAuthContainer, StyledGoogleOAuthFallbackButtonContainer, StyledGoogleOAuthFallbackButtonContent, StyledGoogleOAuthFallbackButtonText, StyledGoogleOAuthDiv } from './GoogleOAuthButton.styles.ts';
import { useGoogleIdentityServices } from './useGoogleIdentityServices';
import { useGoogleLoginNonce } from './useGoogleLoginNonce';
import { useLoadGoogleIdentityServices } from './useLoadGoogleIdentityServices';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { SocialGoogleIcon } from 'foundations-assets';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const GoogleOAuthButton = () => {
  const googleButtonRef = useRef(null);
  const {
    googleSignInNonce,
    didNonceRequestFail
  } = useGoogleLoginNonce();
  const Tracker = useTracker();
  const onAuthenticationFailed = failure => Tracker.signupInteraction(`google-oauth-exception-${failure.reason}`);
  const {
    isLoading,
    isLoaded
  } = useLoadGoogleIdentityServices({
    onAuthenticationFailed
  });
  const isGoogleLibraryLoaded = !isLoading || isLoaded;
  useGoogleIdentityServices({
    googleButtonRef,
    libraryHasLoaded: isGoogleLibraryLoaded,
    googleSignInNonce
  });
  if (didNonceRequestFail) {
    return /*#__PURE__*/_jsx(StyledGoogleOAuthFallbackButtonContainer, {
      children: /*#__PURE__*/_jsx(LoadingButton, {
        block: true,
        "data-test-id": "oauth-button-google-fallback",
        disabled: true,
        paddingBlock: "0",
        paddingInline: "100",
        children: /*#__PURE__*/_jsxs(StyledGoogleOAuthFallbackButtonContent, {
          children: [/*#__PURE__*/_jsx(IconHolder, {
            icon: SocialGoogleIcon,
            marginInlineStart: "100",
            padding: "0",
            size: "600"
          }), /*#__PURE__*/_jsx(StyledGoogleOAuthFallbackButtonText, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: 'views.LANDING_PAGE.googleSignup'
            })
          })]
        })
      })
    });
  }
  return /*#__PURE__*/_jsx(StyledGoogleOAuthContainer, {
    "data-test-id": "oauth-button-google",
    id: "google-oauth-container",
    children: /*#__PURE__*/_jsx(StyledGoogleOAuthDiv, {
      children: isGoogleLibraryLoaded ? /*#__PURE__*/_jsx(StyledGoogleOAuthButton, {
        id: "g_id_onload",
        ref: googleButtonRef
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(StyledGoogleLogoPlaceholder, {}), /*#__PURE__*/_jsx(LoadingSpinner, {
          layout: "centered",
          margin: "auto",
          size: "sm"
        }), /*#__PURE__*/_jsx(StyledGoogleLogoPlaceholder, {})]
      })
    })
  });
};